import React, { useState } from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { Button, Typography } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      padding: '0 0 0 4px',
      display: 'flex',
      alignItems: 'center',
      width: 400,
    },
    input: {
      marginLeft: theme.spacing(1),
      flex: 1,
    },
    iconButton: {
      padding: 10,
    },
    searchButton: {
      padding: 12,
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
    },
  })
);
const NOOP = () => {};
export interface SearchBoxProps {
  handleSearch?: (v: string) => void;
}

export function SearchBox({ handleSearch = NOOP }: SearchBoxProps) {
  const classes = useStyles();
  const [value, setValue] = useState('');

  return (
    <Paper
      component="form"
      className={classes.paper}
      onSubmit={(e) => {
        e.preventDefault();
        handleSearch(value);
      }}
    >
      <IconButton className={classes.iconButton} aria-label="menu">
        <SearchIcon />
      </IconButton>
      <InputBase
        className={classes.input}
        placeholder="Zadejte hledaný výraz"
        inputProps={{ 'aria-label': 'zadejte hledaný výraz' }}
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
      <Button
        type="submit"
        variant="contained"
        color="primary"
        className={classes.searchButton}
      >
        <Typography component="span" variant="body2">
          HLEDAT
        </Typography>
      </Button>
    </Paper>
  );
}
